/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.com/docs/how-to/querying-data/use-static-query/
 */

import React, { useState, useEffect } from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql, Link } from "gatsby"

import Header from "./header"
import CookieConsent from "./CookieConsent"
import "./layout.css"
import fishSnifferLogo from "../images/assets/fishsnifferlogo.png"
import gearlistLogo from "../images/gearlistlogo.png"

const Layout = ({ children }) => {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)

  const [isSidebarOpen, setSidebarOpen] = useState(false)
  const [currentNotificationIndex, setCurrentNotificationIndex] = useState(0)
  const [isTransitioning, setIsTransitioning] = useState(false)

  const notifications = [
    {
      text: "New Fish Sniffer, built with Gearlist — learn more.",
      link: "https://gearlist.com/success-stories/reviving-a-legacy-rebuilding-the-fish-sniffer",
      isExternal: true
    },
    {
      text: "Read the latest issue here",
      link: "/latest-issue/",
      isExternal: false
    }
  ]

  useEffect(() => {
    const interval = setInterval(() => {
      setIsTransitioning(true)
      setTimeout(() => {
        setCurrentNotificationIndex((prevIndex) => 
          (prevIndex + 1) % notifications.length
        )
        setIsTransitioning(false)
      }, 500) // Wait for slide-out animation to complete
    }, 8000) // Rotate every 8 seconds

    return () => clearInterval(interval)
  }, [notifications.length])

  const toggleSidebar = () => {
    setSidebarOpen(!isSidebarOpen)
  }

  const closeSidebar = () => {
    setSidebarOpen(false)
  }

  const navLinks = [
    { name: "Home", path: "/" },
    { name: "About Us", path: "/about/" },
    { name: "Latest Issue", path: "/latest-issue/" },
    { name: "Reports", path: "/reports/" },
    { name: "Maps", path: "/maps/" },
    { name: "Partners", path: "/partners/" },
    { name: "Contact Us", path: "/contact-us/" }
  ]

  return (
    <>
      {/* Pass navLinks and toggle function to Header */}
      <Header
        siteTitle={data.site.siteMetadata?.title || `Title`}
        onToggleSidebar={toggleSidebar}
        navLinks={navLinks}
      />
      {/* Rotating Notification Bar */}
      <div className="notification-bar">
        <div className={`notification-content ${isTransitioning ? 'slide-out' : ''}`}>
          {notifications[currentNotificationIndex].isExternal ? (
            <a 
              href={notifications[currentNotificationIndex].link} 
              target="_blank" 
              rel="noopener noreferrer"
            >
              {notifications[currentNotificationIndex].text}
            </a>
          ) : (
            <Link to={notifications[currentNotificationIndex].link}>
              {notifications[currentNotificationIndex].text}
            </Link>
          )}
        </div>
      </div>
      {/* Sidebar */}
      {/* Add 'is-open' class conditionally */}
      <aside className={`sidebar ${isSidebarOpen ? 'is-open' : ''}`}>
        <h3>Navigation</h3>
        <ul>
          {navLinks.map((link) => (
            <li key={link.name}>
              <Link to={link.path} onClick={closeSidebar}>{link.name}</Link>
            </li>
          ))}
        </ul>
      </aside>

      {/* Overlay */}
      {/* Add 'is-open' class conditionally */}
      {isSidebarOpen && (
        <div
          className={`overlay ${isSidebarOpen ? 'is-open' : ''}`}
          onClick={closeSidebar}
          onKeyDown={e => e.key === 'Escape' && closeSidebar()}
          role="button" // Make it clickable
          tabIndex={0} // Make it focusable
          aria-label="Close Navigation Menu"
        ></div>
      )}


      {/* Main content area */}
      <div
        style={{
          // Keep inline style for minHeight calculation if necessary, or move to CSS
          // minHeight: `calc(100vh - YOUR_HEADER_HEIGHT - YOUR_FOOTER_HEIGHT)`, // Adjust heights - removed for now
        }}
      >
        <main className="main-content">{children}</main> {/* Added class */}
      </div>

      {/* Footer */}
      <footer className="site-footer"> {/* Added class */}
        {/* Powered by Gearlist section */}
        <div className="footer-powered-by">
          <span>Powered by </span>
          <a href="https://gearlist.com/success-stories/reviving-a-legacy-rebuilding-the-fish-sniffer" target="_blank" rel="noopener noreferrer">
            <img src={gearlistLogo} alt="Gearlist" className="footer-gearlist-logo" />
          </a>
        </div>
        
        <div className="footer-logo-container">
          <Link to="/">
            <img src={fishSnifferLogo} alt="The Fish Sniffer Logo" className="footer-logo" />
          </Link>
        </div>
        <div className="footer-content">
          &copy; {new Date().getFullYear()} &middot; The Fish Sniffer
          <div className="footer-legal-links">
            <Link to="/privacy-policy/">Privacy Policy</Link>
            <span>&middot;</span>
            <Link to="/cookie-policy/">Cookie Policy</Link>
            <span>&middot;</span>
            <Link to="/terms-and-conditions/">Terms &amp; Conditions</Link>
            <span>&middot;</span>
            <Link to="/disclaimer/">Disclaimer</Link>
          </div>
        </div>
        {` `}
        {/* <a href="https://www.gatsbyjs.com">Built with Gatsby</a> */}
      </footer>
      
      {/* Cookie Consent Banner */}
      <CookieConsent />
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
